export const mockClients = [
  {
    id: "001",
    name: "Prashant Bhardwaj",
    phone: "9810000000",
    slug: "prashant-bhardwaj",
    status: "Active",
    advisorNote: "Looking for RTM 4BHK in GCR or GCER. Investment + end use.",
  },
  {
    id: "002",
    name: "Rahul Gupta",
    phone: "9899000000",
    slug: "rahul-gupta",
    status: "Active",
    advisorNote: "NRI investor. Yield-focused. Budget ₹5-8Cr.",
  },
];

export const mockProperties = [
  {
    clientId: "001",
    propertyName: "DLF The Camellias",
    developer: "DLF Limited",
    location: "Sector 42, Golf Course Road",
    sizeSqft: "5,800",
    pricePerSqft: "₹48,000",
    ticketSize: "₹28 Cr",
    status: "Ready to Move",
    ndbScore: 91,
    imageUrl: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&q=80",
    highlight1: "Golf-facing unit, unobstructed views",
    highlight2: "Ultra low density — 3 units per floor",
    highlight3: "Most iconic address in NCR",
    whyThisFits: "Matches your RTM requirement with immediate possession",
  },
  {
    clientId: "001",
    propertyName: "Godrej Sora",
    developer: "Godrej Properties",
    location: "Sector 53, Golf Course Road",
    sizeSqft: "3,200",
    pricePerSqft: "₹32,000",
    ticketSize: "₹10.5 Cr",
    status: "Under Construction",
    ndbScore: 84,
    imageUrl: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=800&q=80",
    highlight1: "Japanese-inspired architecture",
    highlight2: "Only 110 units — rare low density",
    highlight3: "Premium GCR address",
    whyThisFits: "Best value play in GCR under ₹12Cr",
  },
  {
    clientId: "001",
    propertyName: "M3M Golf Estate",
    developer: "M3M India",
    location: "Sector 65, Golf Course Ext. Road",
    sizeSqft: "2,800",
    pricePerSqft: "₹22,000",
    ticketSize: "₹6.2 Cr",
    status: "Ready to Move",
    ndbScore: 78,
    imageUrl: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=800&q=80",
    highlight1: "Golf-facing, GCER corridor",
    highlight2: "Flagship M3M project",
    highlight3: "High rental yield zone",
    whyThisFits: "Strong rental yield if you decide to lease first",
  },
  {
    clientId: "002",
    propertyName: "Sobha City",
    developer: "Sobha Limited",
    location: "Sector 108, Dwarka Expressway",
    sizeSqft: "1,850",
    pricePerSqft: "₹14,000",
    ticketSize: "₹2.6 Cr",
    status: "Ready to Move",
    ndbScore: 76,
    imageUrl: "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=800&q=80",
    highlight1: "Benchmark delivery quality",
    highlight2: "39-acre integrated township",
    highlight3: "DXP corridor — airport tunnel open",
    whyThisFits: "Strong rental demand, NRI-friendly management",
  },
];
